module.exports = __webpack_public_path__ + "static/media/10.a2c9c339.jpg";